// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgStarFilled = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.487 2.67c-.61-1.227-2.365-1.227-2.974 0L8.09 7.55l-5.42.788c-1.355.197-1.907 1.863-.916 2.823l3.918 3.794-.925 5.359c-.234 1.36 1.197 2.377 2.406 1.745L12 19.524l4.847 2.535c1.209.632 2.64-.385 2.406-1.745l-.925-5.36 3.918-3.793c.991-.96.439-2.626-.917-2.823l-5.42-.788z"
      clipRule="evenodd"
    />
  </svg>
);
export const StarFilledIcon = forwardRef(SvgStarFilled);
